import { render, staticRenderFns } from "./AuditLogsFilters.vue?vue&type=template&id=bc19934c"
import script from "./AuditLogsFilters.vue?vue&type=script&lang=js"
export * from "./AuditLogsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports